import React from "react";
import { Offcanvas, Nav, NavDropdown } from "react-bootstrap";

import { Link } from "react-router-dom";

const SidebarLeft = ({ show, handleClose }) => {
  return (
    <Offcanvas show={show} onHide={handleClose}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Menu</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Nav className="d-block ">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/participants">Participants</Link>
            </li>
            <li>
              <Link to="/build">Build Program</Link>
            </li>
          </ul>
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SidebarLeft;
